import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, FormsModule } from '@angular/forms';
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { interval } from 'rxjs';
import { debounce } from 'rxjs/operators';

@Component({
  selector: 'app-activity-window-restriction',
  templateUrl: './activity-window-restriction.component.html',
  styleUrls: ['./activity-window-restriction.component.scss'],
})
export class ActivityWindowRestrictionComponent implements OnInit {
  @Input() activityWindow: any;
  conditions: any;
  faTimes = faTimes;
  faPlus = faPlus;
  @Output() public inputChangeEmitter: EventEmitter<any> = new EventEmitter(true);
  debouncer: Subject<string> = new Subject<string>();

  constructor(
    private router: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private formsModule: FormsModule,
    private modalHelper: NgbModal
  ) {
    this.debouncer.pipe(debounce(() => interval(1000))).subscribe((value) => this.inputChangeEmitter.emit(value));
  }

  ngOnInit(): void {
    this.conditions = [
      { value: true, text: 'WITHIN' },
      { value: false, text: 'OUTSIDE OF' },
    ];
  }

  initRestrictionObject(): void {
    var tmpObj = {
      class:
        'com.chiprewards.cheetah.business.rules.config.behavior.v2.BehaviorConfiguration$Restrictions$Behavioral$ActivityWindow',
    };
    if (this.activityWindow) {
      this.activityWindow.push(tmpObj);
    } else {
      this.activityWindow = [];
      this.activityWindow.push(tmpObj);
    }
    console.log(this.activityWindow);
  }

  updateRestrictions() {
    this.debouncer.next(this.activityWindow);
  }

  removeRestriction(restriction) {
    this.activityWindow.splice(this.activityWindow.indexOf(restriction), 1);
    this.updateRestrictions();
  }
}
